/* eslint-disable */
export default {
  Home: 'Home',
  Mobile: 'Mobile',
  Work: 'Work',
} as const;

// @key: @#@"Home"@#@ @source: @#@"Home"@#@
// @key: @#@"Mobile"@#@ @source: @#@"Mobile"@#@
// @key: @#@"Work"@#@ @source: @#@"Work"@#@
